import { Navigate, Link } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';
import { isSuperAdmin } from '../auth';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { isLoggedIn, user } = useUser();
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (!isSuperAdmin(user)) {
    return (
      <div className="auth-shell">
        <div className="auth-panel">
          <div className="auth-brand">Kingfisher</div>
          <h1>Forbidden</h1>
          <p className="auth-subtitle">Only super-admins can access this page.</p>
          <div className="auth-footer"><Link to="/tldr">Back to reader</Link></div>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
